export default __webpack_public_path__ + "static/media/cart1.ba44ebdc.jpg";